import type { I18nFn } from '#/i18n/types/I18nFn';

export function getTimezoneList(i18n: I18nFn) {
  return [
    ['Africa/Abidjan', i18n('Africa/Abidjan')],
    ['Africa/Accra', i18n('Africa/Accra')],
    ['Africa/Addis_Ababa', i18n('Africa/Addis_Ababa')],
    ['Africa/Algiers', i18n('Africa/Algiers')],
    ['Africa/Asmara', i18n('Africa/Asmara')],
    ['Africa/Asmera', i18n('Africa/Asmera')],
    ['Africa/Bamako', i18n('Africa/Bamako')],
    ['Africa/Bangui', i18n('Africa/Bangui')],
    ['Africa/Banjul', i18n('Africa/Banjul')],
    ['Africa/Bissau', i18n('Africa/Bissau')],
    ['Africa/Blantyre', i18n('Africa/Blantyre')],
    ['Africa/Brazzaville', i18n('Africa/Brazzaville')],
    ['Africa/Bujumbura', i18n('Africa/Bujumbura')],
    ['Africa/Cairo', i18n('Africa/Cairo')],
    ['Africa/Casablanca', i18n('Africa/Casablanca')],
    ['Africa/Ceuta', i18n('Africa/Ceuta')],
    ['Africa/Conakry', i18n('Africa/Conakry')],
    ['Africa/Dakar', i18n('Africa/Dakar')],
    ['Africa/Dar_es_Salaam', i18n('Africa/Dar_es_Salaam')],
    ['Africa/Djibouti', i18n('Africa/Djibouti')],
    ['Africa/Douala', i18n('Africa/Douala')],
    ['Africa/El_Aaiun', i18n('Africa/El_Aaiun')],
    ['Africa/Freetown', i18n('Africa/Freetown')],
    ['Africa/Gaborone', i18n('Africa/Gaborone')],
    ['Africa/Harare', i18n('Africa/Harare')],
    ['Africa/Johannesburg', i18n('Africa/Johannesburg')],
    ['Africa/Juba', i18n('Africa/Juba')],
    ['Africa/Kampala', i18n('Africa/Kampala')],
    ['Africa/Khartoum', i18n('Africa/Khartoum')],
    ['Africa/Kigali', i18n('Africa/Kigali')],
    ['Africa/Kinshasa', i18n('Africa/Kinshasa')],
    ['Africa/Lagos', i18n('Africa/Lagos')],
    ['Africa/Libreville', i18n('Africa/Libreville')],
    ['Africa/Lome', i18n('Africa/Lome')],
    ['Africa/Luanda', i18n('Africa/Luanda')],
    ['Africa/Lubumbashi', i18n('Africa/Lubumbashi')],
    ['Africa/Lusaka', i18n('Africa/Lusaka')],
    ['Africa/Malabo', i18n('Africa/Malabo')],
    ['Africa/Maputo', i18n('Africa/Maputo')],
    ['Africa/Maseru', i18n('Africa/Maseru')],
    ['Africa/Mbabane', i18n('Africa/Mbabane')],
    ['Africa/Mogadishu', i18n('Africa/Mogadishu')],
    ['Africa/Monrovia', i18n('Africa/Monrovia')],
    ['Africa/Nairobi', i18n('Africa/Nairobi')],
    ['Africa/Ndjamena', i18n('Africa/Ndjamena')],
    ['Africa/Niamey', i18n('Africa/Niamey')],
    ['Africa/Nouakchott', i18n('Africa/Nouakchott')],
    ['Africa/Ouagadougou', i18n('Africa/Ouagadougou')],
    ['Africa/Porto-Novo', i18n('Africa/Porto-Novo')],
    ['Africa/Sao_Tome', i18n('Africa/Sao_Tome')],
    ['Africa/Timbuktu', i18n('Africa/Timbuktu')],
    ['Africa/Tripoli', i18n('Africa/Tripoli')],
    ['Africa/Tunis', i18n('Africa/Tunis')],
    ['Africa/Windhoek', i18n('Africa/Windhoek')],
    ['America/Adak', i18n('America/Adak')],
    ['America/Anchorage', i18n('America/Anchorage')],
    ['America/Anguilla', i18n('America/Anguilla')],
    ['America/Antigua', i18n('America/Antigua')],
    ['America/Araguaina', i18n('America/Araguaina')],
    ['America/Argentina/Buenos_Aires', i18n('America/Argentina/Buenos_Aires')],
    ['America/Argentina/Catamarca', i18n('America/Argentina/Catamarca')],
    [
      'America/Argentina/ComodRivadavia',
      i18n('America/Argentina/ComodRivadavia'),
    ],
    ['America/Argentina/Cordoba', i18n('America/Argentina/Cordoba')],
    ['America/Argentina/Jujuy', i18n('America/Argentina/Jujuy')],
    ['America/Argentina/La_Rioja', i18n('America/Argentina/La_Rioja')],
    ['America/Argentina/Mendoza', i18n('America/Argentina/Mendoza')],
    ['America/Argentina/Rio_Gallegos', i18n('America/Argentina/Rio_Gallegos')],
    ['America/Argentina/Salta', i18n('America/Argentina/Salta')],
    ['America/Argentina/San_Juan', i18n('America/Argentina/San_Juan')],
    ['America/Argentina/San_Luis', i18n('America/Argentina/San_Luis')],
    ['America/Argentina/Tucuman', i18n('America/Argentina/Tucuman')],
    ['America/Argentina/Ushuaia', i18n('America/Argentina/Ushuaia')],
    ['America/Aruba', i18n('America/Aruba')],
    ['America/Asuncion', i18n('America/Asuncion')],
    ['America/Atikokan', i18n('America/Atikokan')],
    ['America/Atka', i18n('America/Atka')],
    ['America/Bahia', i18n('America/Bahia')],
    ['America/Bahia_Banderas', i18n('America/Bahia_Banderas')],
    ['America/Barbados', i18n('America/Barbados')],
    ['America/Belem', i18n('America/Belem')],
    ['America/Belize', i18n('America/Belize')],
    ['America/Blanc-Sablon', i18n('America/Blanc-Sablon')],
    ['America/Boa_Vista', i18n('America/Boa_Vista')],
    ['America/Bogota', i18n('America/Bogota')],
    ['America/Boise', i18n('America/Boise')],
    ['America/Buenos_Aires', i18n('America/Buenos_Aires')],
    ['America/Cambridge_Bay', i18n('America/Cambridge_Bay')],
    ['America/Campo_Grande', i18n('America/Campo_Grande')],
    ['America/Cancun', i18n('America/Cancun')],
    ['America/Caracas', i18n('America/Caracas')],
    ['America/Catamarca', i18n('America/Catamarca')],
    ['America/Cayenne', i18n('America/Cayenne')],
    ['America/Cayman', i18n('America/Cayman')],
    ['America/Chicago', i18n('America/Chicago')],
    ['America/Chihuahua', i18n('America/Chihuahua')],
    ['America/Coral_Harbour', i18n('America/Coral_Harbour')],
    ['America/Cordoba', i18n('America/Cordoba')],
    ['America/Costa_Rica', i18n('America/Costa_Rica')],
    ['America/Creston', i18n('America/Creston')],
    ['America/Cuiaba', i18n('America/Cuiaba')],
    ['America/Curacao', i18n('America/Curacao')],
    ['America/Danmarkshavn', i18n('America/Danmarkshavn')],
    ['America/Dawson', i18n('America/Dawson')],
    ['America/Dawson_Creek', i18n('America/Dawson_Creek')],
    ['America/Denver', i18n('America/Denver')],
    ['America/Detroit', i18n('America/Detroit')],
    ['America/Dominica', i18n('America/Dominica')],
    ['America/Edmonton', i18n('America/Edmonton')],
    ['America/Eirunepe', i18n('America/Eirunepe')],
    ['America/El_Salvador', i18n('America/El_Salvador')],
    ['America/Ensenada', i18n('America/Ensenada')],
    ['America/Fort_Nelson', i18n('America/Fort_Nelson')],
    ['America/Fort_Wayne', i18n('America/Fort_Wayne')],
    ['America/Fortaleza', i18n('America/Fortaleza')],
    ['America/Glace_Bay', i18n('America/Glace_Bay')],
    ['America/Godthab', i18n('America/Godthab')],
    ['America/Goose_Bay', i18n('America/Goose_Bay')],
    ['America/Grand_Turk', i18n('America/Grand_Turk')],
    ['America/Grenada', i18n('America/Grenada')],
    ['America/Guadeloupe', i18n('America/Guadeloupe')],
    ['America/Guatemala', i18n('America/Guatemala')],
    ['America/Guayaquil', i18n('America/Guayaquil')],
    ['America/Guyana', i18n('America/Guyana')],
    ['America/Halifax', i18n('America/Halifax')],
    ['America/Havana', i18n('America/Havana')],
    ['America/Hermosillo', i18n('America/Hermosillo')],
    ['America/Indiana/Indianapolis', i18n('America/Indiana/Indianapolis')],
    ['America/Indiana/Knox', i18n('America/Indiana/Knox')],
    ['America/Indiana/Marengo', i18n('America/Indiana/Marengo')],
    ['America/Indiana/Petersburg', i18n('America/Indiana/Petersburg')],
    ['America/Indiana/Tell_City', i18n('America/Indiana/Tell_City')],
    ['America/Indiana/Vevay', i18n('America/Indiana/Vevay')],
    ['America/Indiana/Vincennes', i18n('America/Indiana/Vincennes')],
    ['America/Indiana/Winamac', i18n('America/Indiana/Winamac')],
    ['America/Indianapolis', i18n('America/Indianapolis')],
    ['America/Inuvik', i18n('America/Inuvik')],
    ['America/Iqaluit', i18n('America/Iqaluit')],
    ['America/Jamaica', i18n('America/Jamaica')],
    ['America/Jujuy', i18n('America/Jujuy')],
    ['America/Juneau', i18n('America/Juneau')],
    ['America/Kentucky/Louisville', i18n('America/Kentucky/Louisville')],
    ['America/Kentucky/Monticello', i18n('America/Kentucky/Monticello')],
    ['America/Knox_IN', i18n('America/Knox_IN')],
    ['America/Kralendijk', i18n('America/Kralendijk')],
    ['America/La_Paz', i18n('America/La_Paz')],
    ['America/Lima', i18n('America/Lima')],
    ['America/Los_Angeles', i18n('America/Los_Angeles')],
    ['America/Louisville', i18n('America/Louisville')],
    ['America/Lower_Princes', i18n('America/Lower_Princes')],
    ['America/Maceio', i18n('America/Maceio')],
    ['America/Managua', i18n('America/Managua')],
    ['America/Manaus', i18n('America/Manaus')],
    ['America/Marigot', i18n('America/Marigot')],
    ['America/Martinique', i18n('America/Martinique')],
    ['America/Matamoros', i18n('America/Matamoros')],
    ['America/Mazatlan', i18n('America/Mazatlan')],
    ['America/Mendoza', i18n('America/Mendoza')],
    ['America/Menominee', i18n('America/Menominee')],
    ['America/Merida', i18n('America/Merida')],
    ['America/Metlakatla', i18n('America/Metlakatla')],
    ['America/Mexico_City', i18n('America/Mexico_City')],
    ['America/Miquelon', i18n('America/Miquelon')],
    ['America/Moncton', i18n('America/Moncton')],
    ['America/Monterrey', i18n('America/Monterrey')],
    ['America/Montevideo', i18n('America/Montevideo')],
    ['America/Montreal', i18n('America/Montreal')],
    ['America/Montserrat', i18n('America/Montserrat')],
    ['America/Nassau', i18n('America/Nassau')],
    ['America/New_York', i18n('America/New_York')],
    ['America/Nipigon', i18n('America/Nipigon')],
    ['America/Nome', i18n('America/Nome')],
    ['America/Noronha', i18n('America/Noronha')],
    ['America/North_Dakota/Beulah', i18n('America/North_Dakota/Beulah')],
    ['America/North_Dakota/Center', i18n('America/North_Dakota/Center')],
    ['America/North_Dakota/New_Salem', i18n('America/North_Dakota/New_Salem')],
    ['America/Ojinaga', i18n('America/Ojinaga')],
    ['America/Panama', i18n('America/Panama')],
    ['America/Pangnirtung', i18n('America/Pangnirtung')],
    ['America/Paramaribo', i18n('America/Paramaribo')],
    ['America/Phoenix', i18n('America/Phoenix')],
    ['America/Port-au-Prince', i18n('America/Port-au-Prince')],
    ['America/Port_of_Spain', i18n('America/Port_of_Spain')],
    ['America/Porto_Acre', i18n('America/Porto_Acre')],
    ['America/Porto_Velho', i18n('America/Porto_Velho')],
    ['America/Puerto_Rico', i18n('America/Puerto_Rico')],
    ['America/Punta_Arenas', i18n('America/Punta_Arenas')],
    ['America/Rainy_River', i18n('America/Rainy_River')],
    ['America/Rankin_Inlet', i18n('America/Rankin_Inlet')],
    ['America/Recife', i18n('America/Recife')],
    ['America/Regina', i18n('America/Regina')],
    ['America/Resolute', i18n('America/Resolute')],
    ['America/Rio_Branco', i18n('America/Rio_Branco')],
    ['America/Rosario', i18n('America/Rosario')],
    ['America/Santa_Isabel', i18n('America/Santa_Isabel')],
    ['America/Santarem', i18n('America/Santarem')],
    ['America/Santiago', i18n('America/Santiago')],
    ['America/Santo_Domingo', i18n('America/Santo_Domingo')],
    ['America/Sao_Paulo', i18n('America/Sao_Paulo')],
    ['America/Scoresbysund', i18n('America/Scoresbysund')],
    ['America/Shiprock', i18n('America/Shiprock')],
    ['America/Sitka', i18n('America/Sitka')],
    ['America/St_Barthelemy', i18n('America/St_Barthelemy')],
    ['America/St_Johns', i18n('America/St_Johns')],
    ['America/St_Kitts', i18n('America/St_Kitts')],
    ['America/St_Lucia', i18n('America/St_Lucia')],
    ['America/St_Thomas', i18n('America/St_Thomas')],
    ['America/St_Vincent', i18n('America/St_Vincent')],
    ['America/Swift_Current', i18n('America/Swift_Current')],
    ['America/Tegucigalpa', i18n('America/Tegucigalpa')],
    ['America/Thule', i18n('America/Thule')],
    ['America/Thunder_Bay', i18n('America/Thunder_Bay')],
    ['America/Tijuana', i18n('America/Tijuana')],
    ['America/Toronto', i18n('America/Toronto')],
    ['America/Tortola', i18n('America/Tortola')],
    ['America/Vancouver', i18n('America/Vancouver')],
    ['America/Virgin', i18n('America/Virgin')],
    ['America/Whitehorse', i18n('America/Whitehorse')],
    ['America/Winnipeg', i18n('America/Winnipeg')],
    ['America/Yakutat', i18n('America/Yakutat')],
    ['America/Yellowknife', i18n('America/Yellowknife')],
    ['Antarctica/Casey', i18n('Antarctica/Casey')],
    ['Antarctica/Davis', i18n('Antarctica/Davis')],
    ['Antarctica/DumontDUrville', i18n('Antarctica/DumontDUrville')],
    ['Antarctica/Macquarie', i18n('Antarctica/Macquarie')],
    ['Antarctica/Mawson', i18n('Antarctica/Mawson')],
    ['Antarctica/McMurdo', i18n('Antarctica/McMurdo')],
    ['Antarctica/Palmer', i18n('Antarctica/Palmer')],
    ['Antarctica/Rothera', i18n('Antarctica/Rothera')],
    ['Antarctica/South_Pole', i18n('Antarctica/South_Pole')],
    ['Antarctica/Syowa', i18n('Antarctica/Syowa')],
    ['Antarctica/Troll', i18n('Antarctica/Troll')],
    ['Antarctica/Vostok', i18n('Antarctica/Vostok')],
    ['Arctic/Longyearbyen', i18n('Arctic/Longyearbyen')],
    ['Asia/Aden', i18n('Asia/Aden')],
    ['Asia/Almaty', i18n('Asia/Almaty')],
    ['Asia/Amman', i18n('Asia/Amman')],
    ['Asia/Anadyr', i18n('Asia/Anadyr')],
    ['Asia/Aqtau', i18n('Asia/Aqtau')],
    ['Asia/Aqtobe', i18n('Asia/Aqtobe')],
    ['Asia/Ashgabat', i18n('Asia/Ashgabat')],
    ['Asia/Ashkhabad', i18n('Asia/Ashkhabad')],
    ['Asia/Atyrau', i18n('Asia/Atyrau')],
    ['Asia/Baghdad', i18n('Asia/Baghdad')],
    ['Asia/Bahrain', i18n('Asia/Bahrain')],
    ['Asia/Baku', i18n('Asia/Baku')],
    ['Asia/Bangkok', i18n('Asia/Bangkok')],
    ['Asia/Barnaul', i18n('Asia/Barnaul')],
    ['Asia/Beirut', i18n('Asia/Beirut')],
    ['Asia/Bishkek', i18n('Asia/Bishkek')],
    ['Asia/Brunei', i18n('Asia/Brunei')],
    ['Asia/Calcutta', i18n('Asia/Calcutta')],
    ['Asia/Chita', i18n('Asia/Chita')],
    ['Asia/Choibalsan', i18n('Asia/Choibalsan')],
    ['Asia/Chongqing', i18n('Asia/Chongqing')],
    ['Asia/Chungking', i18n('Asia/Chungking')],
    ['Asia/Colombo', i18n('Asia/Colombo')],
    ['Asia/Dacca', i18n('Asia/Dacca')],
    ['Asia/Damascus', i18n('Asia/Damascus')],
    ['Asia/Dhaka', i18n('Asia/Dhaka')],
    ['Asia/Dili', i18n('Asia/Dili')],
    ['Asia/Dubai', i18n('Asia/Dubai')],
    ['Asia/Dushanbe', i18n('Asia/Dushanbe')],
    ['Asia/Famagusta', i18n('Asia/Famagusta')],
    ['Asia/Gaza', i18n('Asia/Gaza')],
    ['Asia/Harbin', i18n('Asia/Harbin')],
    ['Asia/Hebron', i18n('Asia/Hebron')],
    ['Asia/Ho_Chi_Minh', i18n('Asia/Ho_Chi_Minh')],
    ['Asia/Hong_Kong', i18n('Asia/Hong_Kong')],
    ['Asia/Hovd', i18n('Asia/Hovd')],
    ['Asia/Irkutsk', i18n('Asia/Irkutsk')],
    ['Asia/Istanbul', i18n('Asia/Istanbul')],
    ['Asia/Jakarta', i18n('Asia/Jakarta')],
    ['Asia/Jayapura', i18n('Asia/Jayapura')],
    ['Asia/Jerusalem', i18n('Asia/Jerusalem')],
    ['Asia/Kabul', i18n('Asia/Kabul')],
    ['Asia/Kamchatka', i18n('Asia/Kamchatka')],
    ['Asia/Karachi', i18n('Asia/Karachi')],
    ['Asia/Kashgar', i18n('Asia/Kashgar')],
    ['Asia/Kathmandu', i18n('Asia/Kathmandu')],
    ['Asia/Katmandu', i18n('Asia/Katmandu')],
    ['Asia/Khandyga', i18n('Asia/Khandyga')],
    ['Asia/Kolkata', i18n('Asia/Kolkata')],
    ['Asia/Krasnoyarsk', i18n('Asia/Krasnoyarsk')],
    ['Asia/Kuala_Lumpur', i18n('Asia/Kuala_Lumpur')],
    ['Asia/Kuching', i18n('Asia/Kuching')],
    ['Asia/Kuwait', i18n('Asia/Kuwait')],
    ['Asia/Macao', i18n('Asia/Macao')],
    ['Asia/Macau', i18n('Asia/Macau')],
    ['Asia/Magadan', i18n('Asia/Magadan')],
    ['Asia/Makassar', i18n('Asia/Makassar')],
    ['Asia/Manila', i18n('Asia/Manila')],
    ['Asia/Muscat', i18n('Asia/Muscat')],
    ['Asia/Nicosia', i18n('Asia/Nicosia')],
    ['Asia/Novokuznetsk', i18n('Asia/Novokuznetsk')],
    ['Asia/Novosibirsk', i18n('Asia/Novosibirsk')],
    ['Asia/Omsk', i18n('Asia/Omsk')],
    ['Asia/Oral', i18n('Asia/Oral')],
    ['Asia/Phnom_Penh', i18n('Asia/Phnom_Penh')],
    ['Asia/Pontianak', i18n('Asia/Pontianak')],
    ['Asia/Pyongyang', i18n('Asia/Pyongyang')],
    ['Asia/Qatar', i18n('Asia/Qatar')],
    ['Asia/Qostanay', i18n('Asia/Qostanay')],
    ['Asia/Qyzylorda', i18n('Asia/Qyzylorda')],
    ['Asia/Rangoon', i18n('Asia/Rangoon')],
    ['Asia/Riyadh', i18n('Asia/Riyadh')],
    ['Asia/Saigon', i18n('Asia/Saigon')],
    ['Asia/Sakhalin', i18n('Asia/Sakhalin')],
    ['Asia/Samarkand', i18n('Asia/Samarkand')],
    ['Asia/Seoul', i18n('Asia/Seoul')],
    ['Asia/Shanghai', i18n('Asia/Shanghai')],
    ['Asia/Singapore', i18n('Asia/Singapore')],
    ['Asia/Srednekolymsk', i18n('Asia/Srednekolymsk')],
    ['Asia/Taipei', i18n('Asia/Taipei')],
    ['Asia/Tashkent', i18n('Asia/Tashkent')],
    ['Asia/Tbilisi', i18n('Asia/Tbilisi')],
    ['Asia/Tehran', i18n('Asia/Tehran')],
    ['Asia/Tel_Aviv', i18n('Asia/Tel_Aviv')],
    ['Asia/Thimbu', i18n('Asia/Thimbu')],
    ['Asia/Thimphu', i18n('Asia/Thimphu')],
    ['Asia/Tokyo', i18n('Asia/Tokyo')],
    ['Asia/Tomsk', i18n('Asia/Tomsk')],
    ['Asia/Ujung_Pandang', i18n('Asia/Ujung_Pandang')],
    ['Asia/Ulaanbaatar', i18n('Asia/Ulaanbaatar')],
    ['Asia/Ulan_Bator', i18n('Asia/Ulan_Bator')],
    ['Asia/Urumqi', i18n('Asia/Urumqi')],
    ['Asia/Ust-Nera', i18n('Asia/Ust-Nera')],
    ['Asia/Vientiane', i18n('Asia/Vientiane')],
    ['Asia/Vladivostok', i18n('Asia/Vladivostok')],
    ['Asia/Yakutsk', i18n('Asia/Yakutsk')],
    ['Asia/Yangon', i18n('Asia/Yangon')],
    ['Asia/Yekaterinburg', i18n('Asia/Yekaterinburg')],
    ['Asia/Yerevan', i18n('Asia/Yerevan')],
    ['Atlantic/Azores', i18n('Atlantic/Azores')],
    ['Atlantic/Bermuda', i18n('Atlantic/Bermuda')],
    ['Atlantic/Canary', i18n('Atlantic/Canary')],
    ['Atlantic/Cape_Verde', i18n('Atlantic/Cape_Verde')],
    ['Atlantic/Faeroe', i18n('Atlantic/Faeroe')],
    ['Atlantic/Faroe', i18n('Atlantic/Faroe')],
    ['Atlantic/Jan_Mayen', i18n('Atlantic/Jan_Mayen')],
    ['Atlantic/Madeira', i18n('Atlantic/Madeira')],
    ['Atlantic/Reykjavik', i18n('Atlantic/Reykjavik')],
    ['Atlantic/South_Georgia', i18n('Atlantic/South_Georgia')],
    ['Atlantic/St_Helena', i18n('Atlantic/St_Helena')],
    ['Atlantic/Stanley', i18n('Atlantic/Stanley')],
    ['Australia/ACT', i18n('Australia/ACT')],
    ['Australia/Adelaide', i18n('Australia/Adelaide')],
    ['Australia/Brisbane', i18n('Australia/Brisbane')],
    ['Australia/Broken_Hill', i18n('Australia/Broken_Hill')],
    ['Australia/Canberra', i18n('Australia/Canberra')],
    ['Australia/Currie', i18n('Australia/Currie')],
    ['Australia/Darwin', i18n('Australia/Darwin')],
    ['Australia/Eucla', i18n('Australia/Eucla')],
    ['Australia/Hobart', i18n('Australia/Hobart')],
    ['Australia/LHI', i18n('Australia/LHI')],
    ['Australia/Lindeman', i18n('Australia/Lindeman')],
    ['Australia/Lord_Howe', i18n('Australia/Lord_Howe')],
    ['Australia/Melbourne', i18n('Australia/Melbourne')],
    ['Australia/NSW', i18n('Australia/NSW')],
    ['Australia/North', i18n('Australia/North')],
    ['Australia/Perth', i18n('Australia/Perth')],
    ['Australia/Queensland', i18n('Australia/Queensland')],
    ['Australia/South', i18n('Australia/South')],
    ['Australia/Sydney', i18n('Australia/Sydney')],
    ['Australia/Tasmania', i18n('Australia/Tasmania')],
    ['Australia/Victoria', i18n('Australia/Victoria')],
    ['Australia/West', i18n('Australia/West')],
    ['Australia/Yancowinna', i18n('Australia/Yancowinna')],
    ['Brazil/Acre', i18n('Brazil/Acre')],
    ['Brazil/DeNoronha', i18n('Brazil/DeNoronha')],
    ['Brazil/East', i18n('Brazil/East')],
    ['Brazil/West', i18n('Brazil/West')],
    ['CET', i18n('CET')],
    ['CST6CDT', i18n('CST6CDT')],
    ['Canada/Atlantic', i18n('Canada/Atlantic')],
    ['Canada/Central', i18n('Canada/Central')],
    ['Canada/Eastern', i18n('Canada/Eastern')],
    ['Canada/Mountain', i18n('Canada/Mountain')],
    ['Canada/Newfoundland', i18n('Canada/Newfoundland')],
    ['Canada/Pacific', i18n('Canada/Pacific')],
    ['Canada/Saskatchewan', i18n('Canada/Saskatchewan')],
    ['Canada/Yukon', i18n('Canada/Yukon')],
    ['Chile/Continental', i18n('Chile/Continental')],
    ['Chile/EasterIsland', i18n('Chile/EasterIsland')],
    ['Cuba', i18n('Cuba')],
    ['EET', i18n('EET')],
    ['EST', i18n('EST')],
    ['EST5EDT', i18n('EST5EDT')],
    ['Egypt', i18n('Egypt')],
    ['Eire', i18n('Eire')],
    ['Etc/GMT', i18n('Etc/GMT')],
    ['Etc/GMT+0', i18n('Etc/GMT+0')],
    ['Etc/GMT+1', i18n('Etc/GMT+1')],
    ['Etc/GMT+10', i18n('Etc/GMT+10')],
    ['Etc/GMT+11', i18n('Etc/GMT+11')],
    ['Etc/GMT+12', i18n('Etc/GMT+12')],
    ['Etc/GMT+2', i18n('Etc/GMT+2')],
    ['Etc/GMT+3', i18n('Etc/GMT+3')],
    ['Etc/GMT+4', i18n('Etc/GMT+4')],
    ['Etc/GMT+5', i18n('Etc/GMT+5')],
    ['Etc/GMT+6', i18n('Etc/GMT+6')],
    ['Etc/GMT+7', i18n('Etc/GMT+7')],
    ['Etc/GMT+8', i18n('Etc/GMT+8')],
    ['Etc/GMT+9', i18n('Etc/GMT+9')],
    ['Etc/GMT-0', i18n('Etc/GMT-0')],
    ['Etc/GMT-1', i18n('Etc/GMT-1')],
    ['Etc/GMT-10', i18n('Etc/GMT-10')],
    ['Etc/GMT-11', i18n('Etc/GMT-11')],
    ['Etc/GMT-12', i18n('Etc/GMT-12')],
    ['Etc/GMT-13', i18n('Etc/GMT-13')],
    ['Etc/GMT-14', i18n('Etc/GMT-14')],
    ['Etc/GMT-2', i18n('Etc/GMT-2')],
    ['Etc/GMT-3', i18n('Etc/GMT-3')],
    ['Etc/GMT-4', i18n('Etc/GMT-4')],
    ['Etc/GMT-5', i18n('Etc/GMT-5')],
    ['Etc/GMT-6', i18n('Etc/GMT-6')],
    ['Etc/GMT-7', i18n('Etc/GMT-7')],
    ['Etc/GMT-8', i18n('Etc/GMT-8')],
    ['Etc/GMT-9', i18n('Etc/GMT-9')],
    ['Etc/GMT0', i18n('Etc/GMT0')],
    ['Etc/Greenwich', i18n('Etc/Greenwich')],
    ['Etc/UCT', i18n('Etc/UCT')],
    ['Etc/UTC', i18n('Etc/UTC')],
    ['Etc/Universal', i18n('Etc/Universal')],
    ['Etc/Zulu', i18n('Etc/Zulu')],
    ['Europe/Amsterdam', i18n('Europe/Amsterdam')],
    ['Europe/Andorra', i18n('Europe/Andorra')],
    ['Europe/Astrakhan', i18n('Europe/Astrakhan')],
    ['Europe/Athens', i18n('Europe/Athens')],
    ['Europe/Belfast', i18n('Europe/Belfast')],
    ['Europe/Belgrade', i18n('Europe/Belgrade')],
    ['Europe/Berlin', i18n('Europe/Berlin')],
    ['Europe/Bratislava', i18n('Europe/Bratislava')],
    ['Europe/Brussels', i18n('Europe/Brussels')],
    ['Europe/Bucharest', i18n('Europe/Bucharest')],
    ['Europe/Budapest', i18n('Europe/Budapest')],
    ['Europe/Busingen', i18n('Europe/Busingen')],
    ['Europe/Chisinau', i18n('Europe/Chisinau')],
    ['Europe/Copenhagen', i18n('Europe/Copenhagen')],
    ['Europe/Dublin', i18n('Europe/Dublin')],
    ['Europe/Gibraltar', i18n('Europe/Gibraltar')],
    ['Europe/Guernsey', i18n('Europe/Guernsey')],
    ['Europe/Helsinki', i18n('Europe/Helsinki')],
    ['Europe/Isle_of_Man', i18n('Europe/Isle_of_Man')],
    ['Europe/Istanbul', i18n('Europe/Istanbul')],
    ['Europe/Jersey', i18n('Europe/Jersey')],
    ['Europe/Kaliningrad', i18n('Europe/Kaliningrad')],
    ['Europe/Kiev', i18n('Europe/Kiev')],
    ['Europe/Kirov', i18n('Europe/Kirov')],
    ['Europe/Lisbon', i18n('Europe/Lisbon')],
    ['Europe/Ljubljana', i18n('Europe/Ljubljana')],
    ['Europe/London', i18n('Europe/London')],
    ['Europe/Luxembourg', i18n('Europe/Luxembourg')],
    ['Europe/Madrid', i18n('Europe/Madrid')],
    ['Europe/Malta', i18n('Europe/Malta')],
    ['Europe/Mariehamn', i18n('Europe/Mariehamn')],
    ['Europe/Minsk', i18n('Europe/Minsk')],
    ['Europe/Monaco', i18n('Europe/Monaco')],
    ['Europe/Moscow', i18n('Europe/Moscow')],
    ['Europe/Nicosia', i18n('Europe/Nicosia')],
    ['Europe/Oslo', i18n('Europe/Oslo')],
    ['Europe/Paris', i18n('Europe/Paris')],
    ['Europe/Podgorica', i18n('Europe/Podgorica')],
    ['Europe/Prague', i18n('Europe/Prague')],
    ['Europe/Riga', i18n('Europe/Riga')],
    ['Europe/Rome', i18n('Europe/Rome')],
    ['Europe/Samara', i18n('Europe/Samara')],
    ['Europe/San_Marino', i18n('Europe/San_Marino')],
    ['Europe/Sarajevo', i18n('Europe/Sarajevo')],
    ['Europe/Saratov', i18n('Europe/Saratov')],
    ['Europe/Simferopol', i18n('Europe/Simferopol')],
    ['Europe/Skopje', i18n('Europe/Skopje')],
    ['Europe/Sofia', i18n('Europe/Sofia')],
    ['Europe/Stockholm', i18n('Europe/Stockholm')],
    ['Europe/Tallinn', i18n('Europe/Tallinn')],
    ['Europe/Tirane', i18n('Europe/Tirane')],
    ['Europe/Tiraspol', i18n('Europe/Tiraspol')],
    ['Europe/Ulyanovsk', i18n('Europe/Ulyanovsk')],
    ['Europe/Uzhgorod', i18n('Europe/Uzhgorod')],
    ['Europe/Vaduz', i18n('Europe/Vaduz')],
    ['Europe/Vatican', i18n('Europe/Vatican')],
    ['Europe/Vienna', i18n('Europe/Vienna')],
    ['Europe/Vilnius', i18n('Europe/Vilnius')],
    ['Europe/Volgograd', i18n('Europe/Volgograd')],
    ['Europe/Warsaw', i18n('Europe/Warsaw')],
    ['Europe/Zagreb', i18n('Europe/Zagreb')],
    ['Europe/Zaporozhye', i18n('Europe/Zaporozhye')],
    ['Europe/Zurich', i18n('Europe/Zurich')],
    ['GB', i18n('GB')],
    ['GB-Eire', i18n('GB-Eire')],
    ['GMT', i18n('GMT')],
    ['GMT+0', i18n('GMT+0')],
    ['GMT-0', i18n('GMT-0')],
    ['GMT0', i18n('GMT0')],
    ['Greenwich', i18n('Greenwich')],
    ['HST', i18n('HST')],
    ['Hongkong', i18n('Hongkong')],
    ['Iceland', i18n('Iceland')],
    ['Indian/Antananarivo', i18n('Indian/Antananarivo')],
    ['Indian/Chagos', i18n('Indian/Chagos')],
    ['Indian/Christmas', i18n('Indian/Christmas')],
    ['Indian/Cocos', i18n('Indian/Cocos')],
    ['Indian/Comoro', i18n('Indian/Comoro')],
    ['Indian/Kerguelen', i18n('Indian/Kerguelen')],
    ['Indian/Mahe', i18n('Indian/Mahe')],
    ['Indian/Maldives', i18n('Indian/Maldives')],
    ['Indian/Mauritius', i18n('Indian/Mauritius')],
    ['Indian/Mayotte', i18n('Indian/Mayotte')],
    ['Indian/Reunion', i18n('Indian/Reunion')],
    ['Iran', i18n('Iran')],
    ['Israel', i18n('Israel')],
    ['Jamaica', i18n('Jamaica')],
    ['Japan', i18n('Japan')],
    ['Kwajalein', i18n('Kwajalein')],
    ['Libya', i18n('Libya')],
    ['MET', i18n('MET')],
    ['MST', i18n('MST')],
    ['MST7MDT', i18n('MST7MDT')],
    ['Mexico/BajaNorte', i18n('Mexico/BajaNorte')],
    ['Mexico/BajaSur', i18n('Mexico/BajaSur')],
    ['Mexico/General', i18n('Mexico/General')],
    ['NZ', i18n('NZ')],
    ['NZ-CHAT', i18n('NZ-CHAT')],
    ['Navajo', i18n('Navajo')],
    ['PRC', i18n('PRC')],
    ['PST8PDT', i18n('PST8PDT')],
    ['Pacific/Apia', i18n('Pacific/Apia')],
    ['Pacific/Auckland', i18n('Pacific/Auckland')],
    ['Pacific/Bougainville', i18n('Pacific/Bougainville')],
    ['Pacific/Chatham', i18n('Pacific/Chatham')],
    ['Pacific/Chuuk', i18n('Pacific/Chuuk')],
    ['Pacific/Easter', i18n('Pacific/Easter')],
    ['Pacific/Efate', i18n('Pacific/Efate')],
    ['Pacific/Enderbury', i18n('Pacific/Enderbury')],
    ['Pacific/Fakaofo', i18n('Pacific/Fakaofo')],
    ['Pacific/Fiji', i18n('Pacific/Fiji')],
    ['Pacific/Funafuti', i18n('Pacific/Funafuti')],
    ['Pacific/Galapagos', i18n('Pacific/Galapagos')],
    ['Pacific/Gambier', i18n('Pacific/Gambier')],
    ['Pacific/Guadalcanal', i18n('Pacific/Guadalcanal')],
    ['Pacific/Guam', i18n('Pacific/Guam')],
    ['Pacific/Honolulu', i18n('Pacific/Honolulu')],
    ['Pacific/Johnston', i18n('Pacific/Johnston')],
    ['Pacific/Kiritimati', i18n('Pacific/Kiritimati')],
    ['Pacific/Kosrae', i18n('Pacific/Kosrae')],
    ['Pacific/Kwajalein', i18n('Pacific/Kwajalein')],
    ['Pacific/Majuro', i18n('Pacific/Majuro')],
    ['Pacific/Marquesas', i18n('Pacific/Marquesas')],
    ['Pacific/Midway', i18n('Pacific/Midway')],
    ['Pacific/Nauru', i18n('Pacific/Nauru')],
    ['Pacific/Niue', i18n('Pacific/Niue')],
    ['Pacific/Norfolk', i18n('Pacific/Norfolk')],
    ['Pacific/Noumea', i18n('Pacific/Noumea')],
    ['Pacific/Pago_Pago', i18n('Pacific/Pago_Pago')],
    ['Pacific/Palau', i18n('Pacific/Palau')],
    ['Pacific/Pitcairn', i18n('Pacific/Pitcairn')],
    ['Pacific/Pohnpei', i18n('Pacific/Pohnpei')],
    ['Pacific/Ponape', i18n('Pacific/Ponape')],
    ['Pacific/Port_Moresby', i18n('Pacific/Port_Moresby')],
    ['Pacific/Rarotonga', i18n('Pacific/Rarotonga')],
    ['Pacific/Saipan', i18n('Pacific/Saipan')],
    ['Pacific/Samoa', i18n('Pacific/Samoa')],
    ['Pacific/Tahiti', i18n('Pacific/Tahiti')],
    ['Pacific/Tarawa', i18n('Pacific/Tarawa')],
    ['Pacific/Tongatapu', i18n('Pacific/Tongatapu')],
    ['Pacific/Truk', i18n('Pacific/Truk')],
    ['Pacific/Wake', i18n('Pacific/Wake')],
    ['Pacific/Wallis', i18n('Pacific/Wallis')],
    ['Pacific/Yap', i18n('Pacific/Yap')],
    ['Poland', i18n('Poland')],
    ['Portugal', i18n('Portugal')],
    ['ROC', i18n('ROC')],
    ['ROK', i18n('ROK')],
    ['Singapore', i18n('Singapore')],
    ['Turkey', i18n('Turkey')],
    ['UCT', i18n('UCT')],
    ['US/Alaska', i18n('US/Alaska')],
    ['US/Aleutian', i18n('US/Aleutian')],
    ['US/Arizona', i18n('US/Arizona')],
    ['US/Central', i18n('US/Central')],
    ['US/East-Indiana', i18n('US/East-Indiana')],
    ['US/Eastern', i18n('US/Eastern')],
    ['US/Hawaii', i18n('US/Hawaii')],
    ['US/Indiana-Starke', i18n('US/Indiana-Starke')],
    ['US/Michigan', i18n('US/Michigan')],
    ['US/Mountain', i18n('US/Mountain')],
    ['US/Pacific', i18n('US/Pacific')],
    ['US/Samoa', i18n('US/Samoa')],
    ['UTC', i18n('UTC')],
    ['Universal', i18n('Universal')],
    ['W-SU', i18n('W-SU')],
    ['WET', i18n('WET')],
    ['Zulu', i18n('Zulu')],
  ] satisfies [string, string][];
}
